import axios from 'axios';

export const createDynamicLink = async (id) => {
  const isStaging = process.env.REACT_APP_API_URL.includes('staging');

  console.log(isStaging);

  const requestBody = {
    dynamicLinkInfo: {
      domainUriPrefix: process.env.REACT_APP_DYNAMIC_DOMAIN,
      link: `https://malaebapp.com/tournament/${id}`,
      androidInfo: {
        androidPackageName: process.env.REACT_APP_BUNDLE_ID,
      },
      iosInfo: {
        iosBundleId: process.env.REACT_APP_BUNDLE_ID,
      },
    },
    suffix: {
      option: 'SHORT',
    },
  };

  try {
    const response = await axios.post(
      `https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=${process.env.REACT_APP_FIREBASE_KEY}`,
      requestBody,
    );

    return response.data.shortLink;
  } catch (error) {
    console.error('Error creating dynamic link:', error);
    throw error;
  }
};
